/**
 * Returns a formatted date, after converting date from this format YYYYMMDD to MMMM DD, YYYY
 */

export function formatDate(dateStr?: string) {
	if (dateStr) {
		if (/^\d{8}$/.test(dateStr)) {
			const year = dateStr.slice(0, 4);
			const month = dateStr.slice(4, 6);
			const day = dateStr.slice(6, 8);
			const monthNames = [
				'January',
				'February',
				'March',
				'April',
				'May',
				'June',
				'July',
				'August',
				'September',
				'October',
				'November',
				'December',
			];
			return `${monthNames[parseInt(month, 10) - 1]} ${day}, ${year}`;
		}
	}

	return dateStr;
}
